import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractColumn from "./AbstractColumn.js";
import percentage from "../../../../core/percentage.js";

/**
 * Percentage report column.
 *
 * @param {abstractRow} spec.row - row of the cell that we compare from.
 * @param {abstractColumn} spec.column - column of the cell that we compare from.
 */
class PercentageColumn extends AbstractColumn {
	constructor({ row, column } = {}) {
		super(...arguments);

		this._row = row;
		this._column = column;
	}

	setReport(report) {
		super.setReport(report);

		this._row && this._row.setReport(this._report);
		this._column && this._column.setReport(this._report);
	}

	getRow() {
		return this._row;
	}

	getColumn() {
		return this._column;
	}

	getFormatter() {
		return this.getTemplate().shouldMakeAbsolute()
			? percentage.absoluteValueTwoDecimals
			: percentage.forceTwoDecimals;
	}

	isPercentageColumn() {
		return true;
	}

	accept(visitor) {
		return visitor.visitPercentageColumn(this);
	}

	_getDefaultTitle() {
		if (!this._row) {
			return _("Percentage");
		}
		return _("% of {rowTitle}", {
			rowTitle: this._row.getTitle().toString(),
		});
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.row = this._row;
		properties.column = this._column;

		return properties;
	}

	static getType() {
		return "PercentageColumn";
	}
}

export default PercentageColumn;
